<template>
  <span>
    <XmlAttribute
      v-for="(attribute, index) in attributes"
      :key="index"
      :attribute="attribute"
    />
  </span>
</template>
<script>
import { defineComponent } from "vue";
import XmlAttribute from "./XmlAttribute.vue";

export default defineComponent({
  name: "XmlElement",
  components: {
    XmlAttribute,
  },
  props: {
    attributes: Array,
  },
});
</script>
